import React, { useState, useEffect } from "react";
import { roomColumns, roomData } from "./RoomStatusData";
import DataTable from "../../../../../../Common/DataTable/DataTable";
import DataTableHeader from "../../../../../../Common/DataTableHeader/DataTableHeader";
import DataTableFooter from "../../../../../../Common/DataTableFooter/DataTableFooter";
import { useNavigate } from "react-router-dom";
import { getBaseUrl } from "../../../../../../Redux/Config/AppConfig";

const RoomStatusTable = () => {
  const BaseUrl = getBaseUrl();
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalEntries, setTotalEntries] = useState(roomData.length); // use real total if API is used
  const [globalFilter, setGlobalFilter] = useState("");
  const [gloablFilterType, setGloablFilterType] = useState("Booking Id");
  const [islistDataLoading, isSetListDataLoading] = useState(false);

  const handleRoomStatusChange = (roomId, newStatus) => {
  };

  const getStatusColorClass = (status) => {
    switch (status) {
      case "Clean":
        return "bg-success";
      case "Dirty":
        return "bg-danger";
      case "Available":
        return "bg-success";
      case "CheckIn":
        return "bg-info";
      case "Maintenance":
        return "bg-warning";
      default:
        return "bg-secondary";
    }
  };

  useEffect(() => {
    const transformed = roomData.map((data) => ({
      roomNumber: data.roomNumber,
      roomType: data.roomType,
      floor: data.floor,
      checkOut: data.checkOut,
      status: (
        <select
          className={`form-select form-select-sm text-white ${getStatusColorClass(
            data.status
          )}`}
          defaultValue={data.status}
          onChange={(e) => handleRoomStatusChange(data.id, e.target.value)}
          style={{
            width: "fit-content",
            minWidth: "100px",
            fontWeight: 500,
          }}
        >
          <option value="Clean">Clean</option>
          <option value="CheckIn">CheckIn</option>
          <option value="Available">Available</option>
          <option value="Dirty">Dirty</option>
          <option value="Maintenance">Maintenance</option>
        </select>
      ),
    }));

    setData(transformed);
  }, []);

  const totalPages = Math.ceil(totalEntries / pageSize);

  return (
    <>
      <DataTableHeader
        pageSize={pageSize}
        setPageSize={setPageSize}
        globalFilter={globalFilter}
        setGlobalFilter={setGlobalFilter}
        setCurrentPage={setCurrentPage}
        gloablFilterType={gloablFilterType}
        setGloablFilterType={setGloablFilterType}
        flage="roomStatus"
      />

      <DataTable
        columns={roomColumns}
        data={data}
        pageSize={pageSize}
        setPageSize={setPageSize}
        isLoading={islistDataLoading}
      />

      <DataTableFooter
        currentPage={currentPage}
        totalPages={totalPages}
        setCurrentPage={setCurrentPage}
        totalEntries={totalEntries}
        pageSize={pageSize}
      />
    </>
  );
};

export default RoomStatusTable;
